module.exports = __webpack_public_path__ + "img/4_166.601eea16.png";